import React, {useContext, useEffect, useState, useRef, useCallback} from 'react';
import MediaQuery from 'react-responsive';
import Slider from "react-slick";
import classnames from "classnames";
import PageContext from "../../../contexts/Page";
import PlayerContext from "../../../contexts/Player";
import Arrow from "../../svg/Arrow";
import BubbleArrow from "../../BubbleArrow";
import ArrowDown from "../../svg/ArrowUp";
import SlickButtonFix from "../../SlickButtonFix";
import Player from "../../Player";


import "./SliderSection.scss";


const NextArrow = () => {
	return (
		<>
			<MediaQuery maxWidth={768}>
				<ArrowDown mainColor="#FFFFFF"/>
			</MediaQuery>
			<MediaQuery minWidth={769}>
				<Arrow mainColor="#FFFFFF"/>
			</MediaQuery>
		</>
	)
}

const PrevArrow = () => {
	return (
		<>
			<MediaQuery maxWidth={768}>
				<ArrowDown mainColor="#FFFFFF"/>
			</MediaQuery>
			<MediaQuery minWidth={769}>
				<Arrow mainColor="#FFFFFF"/>
			</MediaQuery>
		</>
	)
}

const SliderSection = ({slides}) => {
	const {video,setVideo} = useContext(PlayerContext);
	const sliderRef = useRef();
	const [screenIsNarrow, setScreenIsNarrow] = useState(false);
	const {screenH} = useContext(PageContext);

	useEffect(() => {
		setScreenIsNarrow(sliderRef.current.offsetHeight >= screenH)
	}, [setScreenIsNarrow, sliderRef, screenH])

	const handleClick = useCallback((mode, data) => {
		switch (mode) {
			case "link":
				window.open(data.value,"_blank")
				break;
			case "video":
				setVideo(data)
				break;
			default:
				return;
		}

	}, [setVideo])

	const sliderSettings = {
		autoplay: true,
		dots: false,
		arrows: true,
		infinite: true,
		speed: 800,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		slidesToScroll: 1,
		initialSlide: 0,
		swipe: true,
		touchMove: true,
		easing: "ease-in-out",
		nextArrow: <SlickButtonFix><NextArrow/></SlickButtonFix>,
		prevArrow: <SlickButtonFix><PrevArrow/></SlickButtonFix>,
	};
	return (
		<div
			id="home"
			className={classnames("home-slider slider-container", {"fix-controls": screenIsNarrow})}
			ref={sliderRef}>
			{ video && <Player title={video.title} vimeoId={video.value}/> }

			<MediaQuery minWidth={769}>
				<img
					className="blank-slide"
					src="data:image/png;base64,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"
					aria-hidden={true} alt=""
				/>
			</MediaQuery>
			<div className="slick-wrapper">
				<Slider {...sliderSettings}>
					{
						slides &&
						slides
							.map((slide, index, array) => {
								const data = {
									value: slide.slide_value,
									title: slide.slide_title
								}
								return (
									<div
										key={index}
										className={classnames({"link-like":slide.slide_type!=="statyczny"})}
										onClick={
											() => handleClick(
												slide.slide_type,
												data
											)
										}>
										<p className="slick-slogan">{slide.slide_txt}</p>
										<MediaQuery minWidth={769}>
											<div className="slick-counter">
												<p>
													<span>{index + 1 < 10 ? "0"+(index + 1) : index + 1}
														<span>/</span>
													</span>
													{array.length < 10 ? "0"+array.length : array.length}
												</p>
											</div>

										</MediaQuery>
										<img
											src={slide.slide_img}
											alt={slide.slide_title}
											className="banner"/>
									</div>)
								}
							)
					}
				</Slider>
				<div className="bubble-icon">
					<BubbleArrow animate/>
				</div>
			</div>
		</div>
	);
};

export default SliderSection;